import React, { useEffect } from 'react';

const Map = ({
  className, latitude, longitude,
}) => {
  // Hide the container until we get location information
  const isMapsOk = window.google && window.google.maps;
  if (!isMapsOk || !latitude) {
    return null;
  }

  const initMap = () => {
    const maplatLng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
    const map = new google.maps.Map(document.getElementById('map'), {
      center: maplatLng,
      zoom: 15,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      styles: [
        {
          featureType: 'landscape',
          stylers: [{ saturation: -100 }],
        },
        {
          featureType: 'water',
          stylers: [
            { saturation: -100 },
            { lightness: 14 },
          ],
        }],
    });

    /* eslint-disable no-new */
    new google.maps.Marker({
      map,
      icon: '/img/mapicohotel.png',
      position: maplatLng,
    });
    /* eslint-disable no-new */
  };

  useEffect(() => {
    initMap();
  });
  return (
          <div id="map" className={`dsMap min-w-20 min-h-20 ${className || 'h-full w-full'}`}/>
  );
};

export default Map;
